export default String.raw`
$(".register-form-step-js :input").not(':button,:hidden,:checkbox, select').each(function () {
    $(this).attr({ maxLength : 50 });
});

function changeCountryInSignUp(e) {
    const form = $(e.currentTarget).parents('.form-js');
    const container = $('.register-js');
    const template = container.data('template');
    const include = $(e.currentTarget).val();

    $.get('', {__template: template, __include: '"'+include+'|company"'}, function (result) {
            $(container).html(result.template);
            const registerForm = $(container).find('.register-step-js');
            if (registerForm.length > 0) {
                const vateuSelect = registerForm.find('[name="vateu"]');
                const vateuSelectOptions = vateuSelect.find('option');
                if (vateuSelectOptions.length == 2) {
                    vateuSelect.val($(vateuSelectOptions[1]).val());
                }
            }
        })
        form.find('[name="name"],[name="name2"],[name="street"],[name="streetNo"],[name="unitNo"],[name="zipCode"],[name="city"]').each(function() {
            $(this).val('');
            $(this).attr('readonly', false);
            $('label[for="' + $(this).attr('name') + '"]').attr('readonly', false);
            app.formLabelAnimationOnLoadPage();
        });
}

$(document).ready(function() {
    $('body').on('change', '.register-form-step-js .register-country-js', function(e) {
        changeCountryInSignUp(e);
    });
});

function saveEmailOrPasswordOnSignUp(e){
    const input = $(e.currentTarget);
    const name = input.attr('name');
    if(window.registrationInputs == undefined){
        window.registrationInputs = {};
    }
    if(name == 'email'){
        window.registrationInputs.email = input.val();
    } else {
        window.registrationInputs.password = input.val();
    }
}

$('body').on('change', '.register-form-step-js [name=email], .register-form-step-js [name=password]', function(e) {
    saveEmailOrPasswordOnSignUp(e);
});
`